import css from 'styled-jsx/css'

import { common, sizes, colors } from '../../theme'


export default css`
  .container {
    display: flex;
    flex: 1;
    position: relative;
    align-items: flex-end;
    justify-content: center;
    flex-direction: column;
    pointer-events: none;
    width: 100%;
    max-width: ${sizes.body.desktop.maxWidth};
    max-height: 90rem;
    padding: 5rem 3rem;
  }

  .top-nav {
    display: flex;
    justify-content: space-between;
    align-items: center;
    max-width: ${sizes.body.desktop.maxWidth};
    width: 100%;
    min-height: 8rem;
    padding: 0 3rem;
  }

  .top-nav :global(.back-button) {
    background-color: transparent;
    cursor: pointer;
  }

  .top-nav :global(.logo img) {
    width: 3.8rem;
  }

  .bottom-nav {
    display: flex;
    justify-content: space-between;
    margin-bottom: 5.6rem;
    width: 100%;
    max-width: 144rem;
  }

  .lang-block {
    height: 100;
    align-self: center;
    display: flex;
    align-items: center;
    margin-left: 8rem;
  }

  .other-items-block {
    align-self: flex-end;
    display: flex;
    align-items: center;
    margin-right: 3rem;
  }

  .other-items-block :global(.label) {
    font-family: 'Taviraj-Light', sans-serif;
    font-size: 3.6rem;
    text-transform: none;
    color: ${colors.pureWhite};
  }

  .other-items-block :global(li) {
    position: relative;
    margin-bottom: 0;
  }

  .other-items-block :global(li):first-child:after {
    content: '•';
    font-size: 3rem;
    margin: 0 2rem;
  }

  .label {
    ${common.small};
    font-family: 'Nexa Bold', sans-serif;
    color: ${colors.pureWhite};
    display: block;
    margin-left: 1.4rem;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }

  .links-media {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
    overflow: hidden;
  }

  @media screen and (min-width: ${sizes.media.tablet.endMaxWidth}) {
    .container:hover :global(.route:hover .cloud) {
      opacity: 1;
      transform: scale(1) rotate(0deg);
    }
  
    .container:hover :global(.route:not(:hover) .cloud) {
      opacity: 0;
      transform: scale(0) rotate(10deg);
    }  
  }

  .container > :global(*) {
    pointer-events: auto;
  }


  @media screen and (max-width: ${sizes.media.tablet.maxWidth}) {
    .container {
      padding: 0 3rem;
      flex: unset;
    }

    .links-media {
      display: none;
    }

    .top-nav {
      height: 7rem;
      padding: 0 3rem;
    }

    .bottom-nav { 
      flex-direction: column-reverse;
      margin-bottom: 2rem;
    }

    .other-items-block {
      margin-bottom: 2rem;
    }

    .other-items-block :global(.label) {
      ${common.h6}
      text-transform: uppercase;
    }

    .other-items-block :global(.route) {
      margin-bottom: 0;
    }

    .other-items-block :global(li):first-child:after {
      margin: 0 1rem;
    }

    .lang-block {
      align-self: flex-end;
    }
  }
`
